



class EditModeManager {
  callbacks = [];

  currentActiveId = null;

  setActiveComponent(componentId) {
    if (this.currentActiveId !== componentId) {
      this.currentActiveId = componentId;
      this.callbacks.forEach((callback) => callback(componentId));
    }
  }

  clearActiveComponent() {
    this.currentActiveId = null;
  }

  addEventListener(callback) {
    this.callbacks.push(callback);
  }

  removeEventListener(callback) {
    this.callbacks = this.callbacks.filter((cb) => cb !== callback);
  }

  isActive(componentId) {
    return this.currentActiveId === componentId;
  }
}

const editModeManager = new EditModeManager();
export default editModeManager;